
<!--<app-alerts></app-alerts>-->
<main>
  <section>
    <div class="container-fluid ptb-42">
      <div class="row">
        <div class="col-auto">
          <div class="titles-bdr-r">
            <h1 class="color-primary fs-325remTitles">{{ newsInfo.Titulo_Pagina }}</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="blog">
    <div *ngIf="newsListSize > 0" class="container pb-120 gx-5 gx-lg-0">
      <ngx-masonry [options]="masonryOptions" [ordered]="true">
        <div ngxMasonryItem class="news-card masonry-item" *ngFor="let item of newsList">
          <div class="blog-post-images">
            <a (click)="goToNews(item.documentId)">
              <img [src]="item.Imagem.url" alt="Imagem Notícias CIM Tâmega e Sousa" class="card-img-top">
            </a>
            <div class="blog-categories bg-white"><p class="m-0 text-uppercase fw-800 fs-14px">{{ item.Local }}</p></div>
          </div>
          <div class="bg-white py-4">
            <div class="d-block">
              <p class="fw-700 mb-0 mt-2">{{ item.Titulo }}</p>
              <p class="news-date-font mt-2">{{ item.formattedDate }}</p>
              <a (click)="goToNews(item.documentId)" class="btn btn-link fw-700 px-0">{{ newsInfo.Botao_Ler_Noticia }}<i class="uil uil-eye ms-2 fs-20px"></i></a>
            </div>
          </div>
        </div>
      </ngx-masonry>
      <!-- start pagination -->
      <div *ngIf="newsListPage > newsMaxItems" class="row justify-content-center mt-5">
        <div class="col-lg col-12">
          <pagination [totalItems]="newsListSize" [(ngModel)]="newsListPage" [maxSize]="newsMaxItems"></pagination>
        </div>
      </div>
      <!-- end pagination -->
    </div>
    <div *ngIf="newsListSize == 0" class="container ptb-50-80">
      <div class="row gx-5 gx-lg-0 justify-content-center">
        <div class="col-lg-10 col-12">
          <h3 class="color-primary fw-500">{{newsInfo.Sem_Noticias}}</h3>
        </div>
      </div>
    </div>
  </section>
</main>

